import type { FaireProductEntity } from "../../entity_types/product";

export const p_2xa29d8h7t: FaireProductEntity = {
  token: "p_2xa29d8h7t",
  type: "product",
  name: "Pakalana",
  brandName: "Ke\u0101lia Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/4c6b5a4535b3d059c4c5e70812e44c2ae573fb48bd081d5ae920c06dcfd43352.png",
  priceDollars: 5.67,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/e074e7c5034d13034bb478d2c5d4c3a134e3567afb7277b38865d7f343d0db5e.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
